module.exports = __webpack_public_path__ + "img/imgpublice.fba317c2.png";